import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import BusinessVerificationRequired from '../Layouts/BusinessVerificationRequired/BusinessVerificationRequired';
import ConfirmLogin from '../Layouts/ConfirmLogin/ConfirmLogin';
import KycStatus from '../Layouts/KycStatus/KycStatus';
import ModuleUnderConstruction from '../Layouts/ModuleUnderConstruction/ModuleUnderConstruction';
import PageLoader from '../Layouts/PageLoader/PageLoader';
import PermissionRequired from '../Layouts/PermissionRequired/PermissionRequired';
import $ from 'jquery';
import { onlyAdmins } from '../../utils/utils';
import './CreateNFT.css';

const CreateNFT = (props) => {

    useEffect(() => {
        if (localStorage.getItem('theme') === 'dark') {
            $(".modal").addClass("DarkModal");
            $(".dropdown-menu").addClass("dropdown-menu-dark");
            $(".create-nft-container").addClass("DarkModal");
        }
    }, [])

    // if(props.isLoggedIn && props.toggle.toggle_create_nft === undefined) return <PageLoader />
    // if(props.isLoggedIn && !props.toggle.toggle_create_nft) return <PermissionRequired />

    return (
        <React.Fragment>
            <main>
                <section id="CreateCollectible" className="py-5 SingleNft">
                    <div className="container">
                        <div className="row justify-content-center gx-3" id='zIndexMob'>
                            <div className="col-sm-12 col-md-10 col-lg-8 col-xl-8">
                                <Link to="/" className="Fsize_16 brandnew">
                                    <svg className="mb-1 me-2" viewBox="0 0 14 12" fill="none" width="14" height="14"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M6.29436 0.292893C6.68488 -0.0976311 7.31805 -0.0976311 7.70857 0.292893C8.0991 0.683417 8.0991 1.31658 7.70857 1.70711L4.41568 5H12.9985C13.5508 5 13.9985 5.44772 13.9985 6C13.9985 6.55228 13.5508 7 12.9985 7H4.41568L7.70857 10.2929C8.0991 10.6834 8.0991 11.3166 7.70857 11.7071C7.31805 12.0976 6.68488 12.0976 6.29436 11.7071L0.587252 6L6.29436 0.292893Z"
                                            fill="currentColor"></path>
                                    </svg>
                                    Go back
                                </Link>
                                <h2 className="pt-2">Create collectible</h2>
                                <p className="GreyColor mb-4 Fsize_16 CeraMed">
                                    Choose "Single" to create a unique, one-of-a-kind NFT. Currently, we support single NFT creation to ensure each piece gets the attention it deserves.
                                </p>

                                <div className="row gx-3 mb-4">
                                    <Link className="d-none" id="redirect-to-single" to="/create-single" />

                                    {/* Single NFT Card */}
                                    <div className="col-sm-6 col-lg-4 col-xl-3 col-xxl-3 mb-3 mb-xl-0">
                                        <div
                                            onClick={() => {
                                                if (!props.isLoggedIn) return document.getElementById('loginConfirmationBtn').click();
                                                if (props.toggle.toggle_kyc !== undefined && props.toggle.toggle_kyc == 1)
                                                    if (props.currentUser.kycStatus == 0) return document.getElementById('kycStatusDialogBtn').click();
                                                document.getElementById('redirect-to-single').click();
                                            }}
                                            className="create-nft-card"
                                        >
                                            <span className="create-nft-badge">Available</span>
                                            <div className="create-nft-card-icon-wrapper">
                                                <img
                                                    src="/images/img-single-create.png"
                                                    alt="Single NFT"
                                                    className="create-nft-card-icon"
                                                />
                                            </div>
                                            <strong className="create-nft-card-title d-block">Single</strong>
                                            <p className="create-nft-card-description">
                                                One of a kind collectible
                                            </p>
                                        </div>
                                    </div>

                                    {/* Hidden Links */}
                                    <Link className="d-none" id="redirect-to-b-multiple" to="/create-business-multiple" />
                                    <Link className="d-none" id="redirect-to-equity" to="/create-equity" />

                                    {/* Equity NFT Card - Admin Only */}
                                    {
                                        onlyAdmins(props.currentUser.user_name) && (
                                            <div className="col-sm-6 col-lg-4 col-xl-3 col-xxl-3 mb-3 mb-xl-0">
                                                <div
                                                    onClick={() => {
                                                        if (!props.isLoggedIn) return document.getElementById('loginConfirmationBtn').click();
                                                        if (props.toggle.toggle_kyc !== undefined && props.toggle.toggle_kyc == 1)
                                                            if (props.currentUser.kycStatus == 0) return document.getElementById('kycStatusDialogBtn').click();
                                                        document.getElementById('redirect-to-equity').click();
                                                    }}
                                                    className="create-nft-card"
                                                >
                                                    <span className="create-nft-badge">Admin Only</span>
                                                    <div className="create-nft-card-icon-wrapper">
                                                        <img
                                                            src="/images/img-single-create.png"
                                                            alt="Equity NFT"
                                                            className="create-nft-card-icon"
                                                        />
                                                    </div>
                                                    <strong className="create-nft-card-title d-block">Equity</strong>
                                                    <p className="create-nft-card-description">
                                                        Investment opportunities
                                                    </p>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>

                                <p className="create-nft-footer-text">
                                    We do not own your private keys and cannot access your funds without your confirmation.
                                </p>
                            </div>
                        </div>
                    </div>

                    <ConfirmLogin
                        title={`Want to create NFT?`}
                        message={
                            <p>Please <Link id="link-target" to="/login" />
                                <span style={{ cursor: 'pointer', color: 'blue' }} onClick={() => {
                                    document.getElementById('loginConfirmationBtn').click();
                                    document.getElementById('link-target').click();
                                }}
                                    className="BlueColor">Login</span> to continue creating.
                            </p>
                        }
                    />
                    <BusinessVerificationRequired />
                    <KycStatus />
                    <ModuleUnderConstruction />
                </section>
            </main>
        </React.Fragment>
    )
}

const mapStateToProps = state => ({
    isLoggedIn: state.Auth.isLoggedIn,
    currentUser: state.Profile.profile,
    toggle: state.Settings.toggle
})

export default connect(mapStateToProps, {})(CreateNFT);